import React, {PropTypes} from 'react';

export default function Introduction(props) {

  return (
    <div className='expanded-accordion-content explanation-of-wahve'>
      <div className='callout'>The conversation should begin per below.</div>
      {
        props.script
        &&
        <div className='speaking-callout'>
          <ul className='instructions-list'>
            <li>Thank you for taking the time to complete your application and for taking our assessments.</li>
            <li>I would like to review the application with you as well as spend some time interviewing you.</li>
            <li>This may take a half hour or so. Do you have the time now?</li>
            <li>We will discuss your availability, work objectives and home office setup.</li>
            <li>We will review your work history and professional skills.</li>
            <li>I will then ask you some questions that will help us get to know you.</li>
            <li>Please feel free to ask questions at any time.</li>
          </ul>
        </div>
      }
    </div>
  );
}

Introduction.propTypes = {
  script: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Interview/f_Introduction/index.js